import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة طاقة الفوتون";
const DESCRIPTION =
  "حاسبة طاقة الفوتون الدقيقة: احسب طاقة الفوتون (بالجول أو الإلكترون فولت) باستخدام تردد الموجة أو طولها الموجي وثابت بلانك. أداة أساسية لطلاب الفيزياء والكيمياء والهندسة!";
const KEYWORDS = "طاقة الفوتون, حساب طاقة الفوتون, حاسبة الفوتون";
const OG_URL = "https://do-calculate.com/calculator/ar/photonenergy";
function PhotonEnergyCalculator() {
  const [frequency, setFrequency] = useState("");
  const [photonEnergy, setPhotonEnergy] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!frequency) {
      setError("الرجاء إدخال تردد الفوتون بشكل صحيح");
      setPhotonEnergy("");
      return;
    }
    const frequencyValue = parseFloat(frequency);
    if (isNaN(frequencyValue) || frequencyValue <= 0) {
      setError("الرجاء إدخال قيمة صحيحة وإيجابية لتردد الفوتون");
      setPhotonEnergy("");
      return;
    }
    const planckConstant = 6.626e-34;
    const photonEnergyValue = (planckConstant * frequencyValue).toPrecision(2);
    setPhotonEnergy(photonEnergyValue);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>كيفية حساب طاقة الفوتون</h2>
                <p>
                  يمكن حساب طاقة الفوتون بناءً على تردد الفوتون باستخدام القانون
                  التالي:
                </p>
                <p>طاقة الفوتون (E) = ثابت بلانك (h) × تردد الفوتون (ν)</p>
                <p>الرجاء إدخال تردد الفوتون لحساب طاقة الفوتون.</p>
                <hr />
              </div>
            </div>
                            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          تردد الفوتون (هيرتز)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="2.5e14"
                        value={frequency}
                        onChange={(e) => setFrequency(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب طاقة الفوتون
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {photonEnergy !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            طاقة الفوتون (بالجول): {photonEnergy} جول
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default PhotonEnergyCalculator;
